import React, { useEffect } from 'react';
import HighLightedText from 'components/highLightedText/highLightedText';
import { recordEventCustomOnly } from 'utilities/uTagging';
import { formatText } from '../../core/i18n';

const sendTaggingWhenShowFailedInviteComponent = () => {
    recordEventCustomOnly({
        categoriaEvento: 'eventos onboarding',
        accionEvento: 'errores en formularios',
        etiquetaEvento: 'problema con interviniente',
        categoriaError: 'problema al anadir interviniente',
        descripcionError: 'incluido en otro proceso de onboarding',
    });
};

export const FailedInvite = () => {
    useEffect(() => {
        sendTaggingWhenShowFailedInviteComponent();
    }, []);

    return (
        <HighLightedText
            className="form__hightlight-text form__hightlight-text--error"
            icon={<i className="icons icons--icon-warning-red" />}
        >
            {formatText('jointHolders-somethingWentWrong')}
            <ul>
                <li>{formatText('jointHolders-wrongReason1')}</li>
                <li>{formatText('jointHolders-wrongReason2')}</li>
                <li>{formatText('jointHolders-wrongReason3')}</li>
            </ul>
        </HighLightedText>
    );
};
